'use es6';

import * as DisplayTypes from 'customer-data-filters/filterQueryFormat/DisplayTypes';
import * as OperationTypes from '../OperationTypes';
import { __OCCURRED_INTEGRATION_PROPERTY } from '../ListSegConstants';
import DSFieldRecord from 'customer-data-filters/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import I18n from 'I18n';
const makeIntegrationOccurredField = () => {
  return DSFieldRecord({
    displayType: DisplayTypes.DatetimeDisplayType,
    label: I18n.text('customerDataFilters.FilterEditor.specialOptionValues.occurredIntegration'),
    name: __OCCURRED_INTEGRATION_PROPERTY,
    type: OperationTypes.DATE_TIME
  });
};
export default makeIntegrationOccurredField;